
export const resetCurrentUser = async () => {
	return await post('resetCurrentUser')
}


export const deleteCurrentUser = async () => {
	return await post('deleteCurrentUser')
}